export var TroubleshootingStepName;
(function (TroubleshootingStepName) {
    TroubleshootingStepName["Initial"] = "initial";
    TroubleshootingStepName["VideoIsRefreshing"] = "videoIsRefreshing";
    TroubleshootingStepName["VideoRefreshed"] = "videoRefreshed";
    TroubleshootingStepName["ProblemResolved"] = "problemResolved";
    TroubleshootingStepName["NothingHelped"] = "nothingHelped";
    TroubleshootingStepName["RestartTheCall"] = "restartTheCall";
    TroubleshootingStepName["CallRestarted"] = "callRestarted";
})(TroubleshootingStepName || (TroubleshootingStepName = {}));
